export const dasaraInitialData = [
  {
    dayNumber: 1,
    titleTelugu: 'శ్రీ బాలా త్రిపురసుందరీ దేవి',
    titleEnglish: 'Sri Bala Tripura Sundari Devi',
    tithi: 'Padyami',
    tithiTelugu: 'పాడ్యమి',
    date2025: 'October 11, 2026',
    dayOfWeek2025: 'Sunday',
    avatarImageUrl: '/dasara/day1.jpg',
    colorName: 'Golden Yellow',
    colorNameTelugu: 'బంగారు పసుపు',
    colorCode: '#FFD700',
    devoteeColorAdvice: 'Wear Golden Yellow to invoke the blessings of Sri Bala Tripura Sundari Devi.',
    prasadams: [
      { telugu: 'కట్టె పొంగలి', english: 'Katte Pongali', description: 'Savory ven pongal' },
      { telugu: 'చలిమిడి', english: 'Chalimidi', description: 'Sweet rice flour dough' },
      { telugu: 'వడపప్పు', english: 'Vadapappu', description: 'Soaked moong dal' }
    ],
    mantras: [
      {
        telugu: 'సర్వమంగళ మాంగల్యే శివే సర్వార్థ సాధికే |\nశరణ్యే త్రయంబకే గౌరి నారాయణి నమోస్తుతే ||',
        transliteration: 'Sarva Mangala Mangalye Shive Sarvartha Sadhike | Sharanye Trayambake Gauri Narayani Namostute ||',
        meaning: 'Salutations to the auspicious one, who is the bestower of all desires.'
      },
      {
        telugu: 'ఓం ఐం క్లీం సౌః సౌః క్లీం ఐం శ్రీ బాలాత్రిపురసుందర్యై నమః',
        transliteration: 'Om Aim Kleem Sauh Sauh Kleem Aim Sri Bala Tripura Sundaryai Namah',
        meaning: 'Bala Moola Mantra'
      }
    ],
    rituals: [
      { title: 'Kalasa Sthapana & Ankurarpanam', titleTelugu: 'కలశ స్థాపన & అంకురార్పణం', description: 'Kalasa Sthapana & Ankurarpanam' },
      { title: 'Ganapathi Homam', titleTelugu: 'గణపతి హోమం', description: 'Ganapathi Homam' },
      { title: 'Akhanda Deeparadhana', titleTelugu: 'అఖండ దీపారాధన', description: 'Akhanda Deeparadhana' },
      { title: 'Kumkumarchana with Lalitha Ashtothara', titleTelugu: 'కుంకుమార్చన (లలితా అష్టోత్తరము)', description: 'Kumkumarchana with Lalitha Ashtothara' }
    ],
    kalasaDetails: 'కలశస్య ముఖే విష్ణుః కంఠే రుద్రః సమాశ్రితః | మూలే తత్ర స్థితో బ్రహ్మా మధ్యే మాతృగణాః స్మృతాః || — Performed on Aswayuja Suddha Padyami during morning hours. Materials: Copper/brass Kalasam, raw rice, holy water, five mango leaves, coconut, red/yellow cloth, betel leaves.',
    significance: 'The benign child goddess initiating the festival. First step in Sri Vidya Upasana.',
    significanceTelugu: 'నవరాత్రుల ప్రారంభంలో దర్శనమిచ్చే పసితనపు మాతృమూర్తి.'
  },
  {
    dayNumber: 2,
    titleTelugu: 'శ్రీ గాయత్రీ దేవి',
    titleEnglish: 'Sri Gayatri Devi',
    tithi: 'Vidiya',
    tithiTelugu: 'విదియ',
    date2025: 'October 12, 2026',
    dayOfWeek2025: 'Monday',
    avatarImageUrl: '/dasara/day2.jpg',
    colorName: 'Orange/Saffron',
    colorNameTelugu: 'నారింజ / కాషాయం',
    colorCode: '#FF8C00',
    devoteeColorAdvice: 'Wear Orange/Saffron to invoke the blessings of Sri Gayatri Devi.',
    prasadams: [
      { telugu: 'పులిహోర', english: 'Pulihora', description: 'Tamarind Rice' },
      { telugu: 'రవ్వ కేసరి', english: 'Rava Kesari', description: 'Sweet semolina dessert' },
      { telugu: 'కొబ్బరి అన్నం', english: 'Coconut Rice', description: 'Coconut flavored rice' }
    ],
    mantras: [
      {
        telugu: 'ఓం భూర్భువస్సువః | తత్సవితుర్వరేణ్యం | భర్గో దేవస్య ధీమహి | ధియో యో నః ప్రచోదయాత్ ||',
        transliteration: 'Om Bhur Bhuvah Svah | Tat Savitur Varenyam | Bhargo Devasya Dheemahi | Dhiyo Yo Nah Prachodayaat ||',
        meaning: 'Gayatri Mantra'
      }
    ],
    rituals: [
      { title: 'Gayatri Japa Yagnam', titleTelugu: 'గాయత్రీ జప యజ్ఞం', description: '108/1008 times' },
      { title: 'Veda Parayanam', titleTelugu: 'వేద పారాయణం', description: 'Chanting of Vedas' }
    ],
    kalasaDetails: null,
    significance: 'Veda Mata - Mother of Vedas, Panchamukhi (five faces), protector of cosmic rhythm.',
    significanceTelugu: 'వేదమాత, పంచముఖి, సకల ప్రాణులకు ప్రాణాధారమైన శక్తి.'
  },
  {
    dayNumber: 3,
    titleTelugu: 'శ్రీ అన్నపూర్ణా దేవి',
    titleEnglish: 'Sri Annapurna Devi',
    tithi: 'Tadiya',
    tithiTelugu: 'తదియ',
    date2025: 'October 13, 2026',
    dayOfWeek2025: 'Tuesday',
    avatarImageUrl: '/dasara/day3.jpg',
    colorName: 'Cream/Off-White',
    colorNameTelugu: 'గంధం రంగు / పసుపు పచ్చ',
    colorCode: '#FFFDD0',
    devoteeColorAdvice: 'Wear Cream/Off-White to invoke the blessings of Sri Annapurna Devi.',
    prasadams: [
      { telugu: 'దద్దోజనం', english: 'Dadhyojanam', description: 'Curd Rice' },
      { telugu: 'పరమాన్నం', english: 'Paramannam', description: 'Sweet milk rice' },
      { telugu: 'పూర్ణాలు', english: 'Purnalu', description: 'Sweet lentil dumplings' }
    ],
    mantras: [
      {
        telugu: 'నిత్యానందకరీ వరాభయకరీ సౌందర్యరత్నాకరీ\nనిర్ధూతాఖిల ఘోరపావనకరీ ప్రత్యక్ష మాహేశ్వరీ |\nప్రాలేయాచల వంశపావనకరీ కాశీపురాధీశ్వరీ\nభిక్షాం దేహి కృపావలంబనకరీ మాతాన్నపూర్ణేశ్వరీ ||',
        transliteration: 'Nityanandakari Varabhayakari Soundarya Ratnakari Nirdhootakhila Ghora Paavanakari Pratyaksha Maheshwari | Praleyachala Vamsha Paavanakari Kashipuradheeshwari Bhiksham Dehi Krupavalambanakari Mata Annapurneshwari ||',
        meaning: 'Annapurna Ashtakam'
      }
    ],
    rituals: [
      { title: 'Dhanya Puja', titleTelugu: 'ధాన్య పూజ', description: 'Worship of grains' },
      { title: 'Maha Anna Daanam', titleTelugu: 'మహా అన్నదానం', description: 'Mass food distribution' }
    ],
    kalasaDetails: null,
    significance: 'Supreme goddess of food and nourishment who granted Bhiksha to Lord Shiva in Kashi.',
    significanceTelugu: 'జీవకోటికి అన్నమును ప్రసాదించే జగన్మాత.'
  },
  {
    dayNumber: 4,
    titleTelugu: 'శ్రీ కాత్యాయనీ దేవి',
    titleEnglish: 'Sri Katyayani Devi',
    tithi: 'Chavithi',
    tithiTelugu: 'చవితి',
    date2025: 'October 14, 2026',
    dayOfWeek2025: 'Wednesday',
    avatarImageUrl: '/dasara/day4.jpg',
    colorName: 'Crimson Red',
    colorNameTelugu: 'ముదురు ఎరుపు',
    colorCode: '#DC143C',
    devoteeColorAdvice: 'Wear Crimson Red to invoke the blessings of Sri Katyayani Devi.',
    prasadams: [
      { telugu: 'పెసర గారెలు', english: 'Pesara Garelu', description: 'Green gram vadas' },
      { telugu: 'కట్టె పొంగలి', english: 'Katte Pongali', description: 'Savory ven pongal' },
      { telugu: 'రవ్వ కేసరి', english: 'Rava Kesari', description: 'Sweet semolina dessert' }
    ],
    mantras: [
      {
        telugu: 'చంద్రహాసోజ్జ్వలకరా శార్దూలవరవాహనా |\nకాత్యాయనీ శుభం దద్యాద్ దేవీ దానవఘాతినీ ||',
        transliteration: 'Chandrahasojjvalakara Shardulavaravahana | Katyayani Shubham Dadyad Devi Danavaghatini ||',
        meaning: 'Mantra for Katyayani Devi'
      }
    ],
    rituals: [
      { title: 'Katyayani Vratam', titleTelugu: 'కాత్యాయనీ వ్రతం', description: 'Katyayani Vratam' },
      { title: 'Sri Chakra Puja', titleTelugu: 'శ్రీ చక్ర పూజ', description: 'Sri Chakra Puja' }
    ],
    kalasaDetails: null,
    significance: 'Born from Sage Katyayana\'s penance, removes hurdles in marriage and relationships.',
    significanceTelugu: 'వివాహ ప్రతిబంధకాలను తొలగించే కరుణామయి.'
  },
  {
    dayNumber: 5,
    titleTelugu: 'శ్రీ లలితా త్రిపురసుందరీ దేవి',
    titleEnglish: 'Sri Lalitha Tripura Sundari Devi',
    tithi: 'Panchami',
    tithiTelugu: 'పంచమి',
    date2025: 'October 15, 2026',
    dayOfWeek2025: 'Thursday',
    avatarImageUrl: '/dasara/day5.jpg',
    colorName: 'Rose Pink',
    colorNameTelugu: 'గులాబీ రంగు',
    colorCode: '#FF69B4',
    devoteeColorAdvice: 'Wear Rose Pink to invoke the blessings of Sri Lalitha Tripura Sundari Devi.',
    prasadams: [
      { telugu: 'బెల్లం పరమాన్నం', english: 'Bellam Paramannam', description: 'Jaggery rice pudding' },
      { telugu: 'పూర్ణం బూరెలు', english: 'Purnam Boorelu', description: 'Sweet stuffed dumplings' },
      { telugu: 'అటుకులు-బెల్లం', english: 'Atukulu-Bellam', description: 'Beaten rice with jaggery' }
    ],
    mantras: [
      {
        telugu: 'సింధూరారుణ విగ్రహాం త్రినయనాం మాణిక్య మౌళిస్ఫురత్\nతారానాయక శేఖరాం స్మితముఖీ మాపీన వక్షోరుహామ్ |\nపాణిభ్యామళిపూర్ణ రత్నచషకం రక్తోత్పలం బిభ్రతీం\nసౌమ్యాం రత్నఘటస్థ రక్తచరణాం ధ్యాయేత్పరామంబికామ్ ||',
        transliteration: 'Sindhooraaruna vigrahaam trinayanaam maanikya maolisphurat Taaraanaayaka shekharaam smitamukheem aapeena vakshoruhaam | Paanibhyaam alipoorna ratnachashakam raktotpalam bibhrateem Saomyaam ratnaghatastha raktacharanaam dhyaayet paraamambikaam ||',
        meaning: 'Lalitha Sahasranama Dhyanam'
      }
    ],
    rituals: [
      { title: 'Sri Chakra Navavarana Archana', titleTelugu: 'శ్రీ చక్ర నవావరణ అర్చన', description: 'Sri Chakra Navavarana Archana' },
      { title: 'Lalitha Sahasranama Kumkumarchana', titleTelugu: 'లలితా సహస్రనామ కుంకుమార్చన', description: 'Lalitha Sahasranama Kumkumarchana' },
      { title: 'Suvasini Puja', titleTelugu: 'సువాసినీ పూజ', description: 'Suvasini Puja' }
    ],
    kalasaDetails: null,
    significance: 'Sovereign Queen of Sri Chakra, slayer of Bhandasura, embodiment of divine grace.',
    significanceTelugu: 'శ్రీ చక్ర అధిష్టాన దేవత, భండాసుర సంహారిణి.'
  },
  {
    dayNumber: 6,
    titleTelugu: 'శ్రీ మహా సరస్వతీ దేవి',
    titleEnglish: 'Sri Maha Saraswati Devi',
    tithi: 'Moola Nakshatram',
    tithiTelugu: 'మూలా నక్షత్రం',
    date2025: 'October 16, 2026',
    dayOfWeek2025: 'Friday',
    avatarImageUrl: '/dasara/day6.jpg',
    colorName: 'Pure White',
    colorNameTelugu: 'శ్వేత వర్ణం',
    colorCode: '#FFFFFF',
    devoteeColorAdvice: 'Wear Pure White to invoke the blessings of Sri Maha Saraswati Devi on auspicious Moola Nakshatram.',
    prasadams: [
      { telugu: 'దద్దోజనం', english: 'Dadhyojanam', description: 'Curd Rice' },
      { telugu: 'క్షీరాన్నం', english: 'Ksheerannam', description: 'Milk rice pudding' },
      { telugu: 'కదంబం', english: 'Kadambam', description: 'Mixed vegetable rice' }
    ],
    mantras: [
      {
        telugu: 'సరస్వతి నమస్తుభ్యం వరదే కామరూపిణి |\nవిద్యారంభం కరిష్యామి సిద్ధిర్భవతు మే సదా ||\n\nయా కుందేందు తుషారహార ధవళా యా శుభ్రవస్త్రావృతా\nయా వీణావరదండ మండితకరా యా శ్వేతపద్మాసనా |\nయా బ్రహ్మాచ్యుత శంకర ప్రభృతిభిర్దేవైః సదా పూజితా\nసా మాం పాతు సరస్వతీ భగవతీ నిశ్శేష జాడ్యాపహా ||',
        transliteration: 'Saraswati Namastubhyam Varade Kaamaroopini | Vidyarambham Karishyami Siddhirbhavatu Me Sadaa || Yaa Kundendu Tushaara Haara Dhavalaa Yaa Shubhra Vastraavrutaa Yaa Veenaavara Danda Manditakaraa Yaa Shweta Padmaasanaa | Yaa Brahmaachyuta Shankara Prabhritibhir Devaih Sadaa Poojitaa Saa Maam Paatu Saraswati Bhagavati Nihshesha Jaadyaapahaa ||',
        meaning: 'Saraswati Vandana - Salutations to the Goddess of wisdom and arts.'
      }
    ],
    rituals: [
      { title: 'Aksharabhyasam', titleTelugu: 'అక్షరాభ్యాసం', description: 'Children\'s sacred initiation into reading and writing' },
      { title: 'Pustaka Puja', titleTelugu: 'పుస్తక పూజ', description: 'Worship of sacred books, musical instruments and learning tools' },
      { title: 'AP Govt presents Pattu Vastralu', titleTelugu: 'ప్రభుత్వ లాంఛనాలతో పట్టు వస్త్రాల సమర్పణ', description: 'AP State Government officially presents silk garments to Ammavaru' }
    ],
    kalasaDetails: null,
    significance: 'Crown jewel day of Vijayawada Dasara! Goddess Kanaka Durga\'s Janma Nakshatram. Devotees line up from 2 AM for the darshan of Sri Saraswati Devi.',
    significanceTelugu: 'మూలా నక్షత్రంలో అమ్మవారి జన్మదినం, విజయవాడ దసరా ఉత్సవాలలో అత్యంత పవిత్రమైన రోజు. వేలాది మంది చిన్నారులకు అక్షరాభ్యాసం జరుగుతుంది.'
  },
  {
    dayNumber: 7,
    titleTelugu: 'శ్రీ మహాలక్ష్మీ దేవి',
    titleEnglish: 'Sri Maha Lakshmi Devi',
    tithi: 'Saptami',
    tithiTelugu: 'సప్తమి',
    date2025: 'October 17, 2026',
    dayOfWeek2025: 'Saturday',
    avatarImageUrl: '/dasara/day7.jpg',
    colorName: 'Pink / Gold',
    colorNameTelugu: 'గులాబీ / బంగారు',
    colorCode: '#FFB6C1',
    devoteeColorAdvice: 'Wear Lotus Pink or Golden yellow to invoke the blessings of Sri Maha Lakshmi Devi.',
    prasadams: [
      { telugu: 'బెల్లం పరమాన్నం', english: 'Bellam Paramannam', description: 'Jaggery rice pudding' },
      { telugu: 'పూర్ణం బూరెలు', english: 'Purnam Boorelu', description: 'Sweet stuffed dumplings' },
      { telugu: 'అటుకులు-బెల్లం', english: 'Atukulu-Bellam', description: 'Beaten rice with jaggery' }
    ],
    mantras: [
      {
        telugu: 'నమస్తేస్తు మహామాయే శ్రీపీఠే సురపూజితే |\nశంఖచక్ర గదాహస్తే మహాలక్ష్మి నమోస్తుతే ||',
        transliteration: 'Namastestu Mahamaye Sreepeethe Surapoojite | Shankha Chakra Gadahaste Mahalakshmi Namostute ||',
        meaning: 'Mahalakshmi Ashtakam - Salutations to the great mother who holds conch, discus and mace.'
      },
      {
        telugu: 'ఓం శ్రీం హ్రీం శ్రీం కమలే కమలాలయే ప్రసీద ప్రసీద శ్రీం హ్రీం శ్రీం ఓం మహాలక్ష్మ్యై నమః',
        transliteration: 'Om Shreem Hreem Shreem Kamale Kamalalaye Praseeda Praseeda Shreem Hreem Shreem Om Mahalakshmyai Namah',
        meaning: 'Mahalakshmi Moola Mantra'
      }
    ],
    rituals: [
      { title: 'Kanakadhara Stotra Parayanam', titleTelugu: 'కనకధారా స్తోత్ర పారాయణం', description: 'Recitation of Sri Adi Shankara\'s Kanakadhara Stotram' },
      { title: 'Lakshmi Sahasranama Archana', titleTelugu: 'లక్ష్మీ సహస్రనామ అర్చన', description: 'Archana with 1000 names of Lakshmi' },
      { title: 'Deepa Puja', titleTelugu: 'దీప పూజ', description: 'Auspicious evening lamp worship' }
    ],
    kalasaDetails: null,
    significance: 'Presiding deity of divine wealth, fortune, and Ashta Lakshmi Swaroopam granting peace and abundance.',
    significanceTelugu: 'సకల సంపదలకు అధిదేవత, అష్టలక్ష్మీ స్వరూపంగా దర్శనమిచ్చి దారిద్ర్యాన్ని తొలగించే మహాతల్లి.'
  },
  {
    dayNumber: 8,
    titleTelugu: 'శ్రీ దుర్గా దేవి',
    titleEnglish: 'Sri Durga Devi',
    tithi: 'Ashtami (Durgashtami)',
    tithiTelugu: 'దుర్గాష్టమి',
    date2025: 'October 18, 2026',
    dayOfWeek2025: 'Sunday',
    avatarImageUrl: '/dasara/day8.jpg',
    colorName: 'Deep Red',
    colorNameTelugu: 'ఎరుపు',
    colorCode: '#8B0000',
    devoteeColorAdvice: 'Wear Deep Red to invoke the blessings of Sri Durga Devi on Durgashtami.',
    prasadams: [
      { telugu: 'కట్టె పొంగలి', english: 'Katte Pongali', description: 'Savory ven pongal' },
      { telugu: 'కదంబం', english: 'Kadambam', description: 'Mixed vegetable rice' },
      { telugu: 'గారెలు', english: 'Garelu', description: 'Medu Vadas' }
    ],
    mantras: [
      {
        telugu: 'సర్వస్వరూపే సర్వేశే సర్వశక్తి సమన్వితే |\nభయేభ్యస్త్రాహి నో దేవి దుర్గే దేవి నమోస్తుతే ||',
        transliteration: 'Sarvasvaroope Sarveshe Sarvashakti Samanvite | Bhayebhyastraahi No Devi Durge Devi Namostute ||',
        meaning: 'Durga Mantra - O Divine Mother, embodiment of all powers, protect us from all fears.'
      }
    ],
    rituals: [
      { title: 'Chandi Homam / Maha Rudra Homam', titleTelugu: 'చండీ హోమం / మహా రుద్ర హోమం', description: 'Sacred fire rituals for peace and world prosperity' },
      { title: 'Kumbha Harati', titleTelugu: 'కుంభ హారతి', description: 'Grand camphor flame aarti offered to Ammavaru' }
    ],
    kalasaDetails: null,
    significance: 'Supreme warrior form, Simha Vahini (riding the lion), conquering internal negative tendencies and demons.',
    significanceTelugu: 'దుర్గతులను నాశనం చేసే సింహవాహిని, దుర్గాష్టమి నాడు అమ్మవారికి అత్యంత వైభవంగా చండీ హోమం జరుగుతుంది.'
  },
  {
    dayNumber: 9,
    titleTelugu: 'శ్రీ మహిషాసుర మర్దినీ దేవి',
    titleEnglish: 'Sri Mahishasura Mardhini Devi',
    tithi: 'Navami (Mahanavami)',
    tithiTelugu: 'మహార్నవమి',
    date2025: 'October 19, 2026',
    dayOfWeek2025: 'Monday',
    avatarImageUrl: '/dasara/day9.jpg',
    colorName: 'Fire Orange',
    colorNameTelugu: 'నారింజ / పసుపు',
    colorCode: '#FF4500',
    devoteeColorAdvice: 'Wear Fire Orange or Yellow on Mahanavami to celebrate divine valor and victory.',
    prasadams: [
      { telugu: 'గారెలు', english: 'Garelu', description: 'Medu Vadas' },
      { telugu: 'చిత్రాన్నం', english: 'Chitrannam', description: 'Lemon Rice' },
      { telugu: 'చక్కెర పొంగలి', english: 'Chakkera Pongali', description: 'Sweet rice pudding' }
    ],
    mantras: [
      {
        telugu: 'అయి గిరినందిని నందితమేదిని విశ్వవినోదిని నందినుతే\nగిరివరవింధ్య శిరోధినివాసిని విష్ణువిలాసిని జిష్ణునుతే |\nభగవతి హే శితికంఠకుటుంబిని భూరి కుటుంబిని భూరి కృతే\nజయ జయ హే మహిషాసురమర్దిని రమ్యకపర్దిని శైలసుతే ||',
        transliteration: 'Ayi Giri Nandini Nandita Medini Vishva Vinodini Nandi Nute Giri Vara Vindhya Shirodhi Nivasini Vishnu Vilasini Jishnu Nute | Bhagavati He Shiti Kantha Kutumbini Bhoori Kutumbini Bhoori Krite Jaya Jaya He Mahishasura Mardini Ramya Kapardini Shaila Sute ||',
        meaning: 'Mahishasura Mardini Stotram - Victory to the slayer of demon Mahishasura.'
      }
    ],
    rituals: [
      { title: 'Ayudha Puja', titleTelugu: 'ఆయుధ పూజ', description: 'Worship of tools, vehicles, books, machinery and computers' },
      { title: 'Yagna Poornahuti', titleTelugu: 'నవరాత్రి యజ్ఞ పూర్ణాహుతి', description: 'Sacred completion offering in yagnas' }
    ],
    kalasaDetails: null,
    significance: 'Fierce triumphant battle form defeating demon Mahishasura. Ultimate victory of dharma and truth.',
    significanceTelugu: 'మహిషాసురుణ్ణి త్రిశూలంతో సంహరించి లోకాలకు శాంతిని ప్రసాదించిన విజయ రూపం. ఈ రోజున ఆయుధ పూజ నిర్వహిస్తారు.'
  },
  {
    dayNumber: 10,
    titleTelugu: 'శ్రీ రాజరాజేశ్వరీ దేవి',
    titleEnglish: 'Sri Raja Rajeswari Devi',
    tithi: 'Dasami (Vijayadasami)',
    tithiTelugu: 'విజయదశమి',
    date2025: 'October 20, 2026',
    dayOfWeek2025: 'Tuesday',
    avatarImageUrl: '/dasara/day10.jpg',
    colorName: 'Green / Gold',
    colorNameTelugu: 'పచ్చని పట్టు వస్త్రం',
    colorCode: '#2E8B57',
    devoteeColorAdvice: 'విజయదశమి నాడు పచ్చని లేదా బంగారు రంగు పట్టు వస్త్రాలు ధరించడం పరమ పవిత్రం.',
    prasadams: [
      { telugu: 'చక్కెర పొంగలి', english: 'Chakkera Pongali', description: 'Sweet jaggery/sugar rice with dry fruits' },
      { telugu: 'పులిహోర', english: 'Pulihora', description: 'Traditional tamarind rice' },
      { telugu: 'పూర్ణం బూరెలు', english: 'Purnam Boorelu', description: 'Sweet chana dal stuffed fritters' },
      { telugu: 'దద్దోజనం', english: 'Dadhyojanam', description: 'Tempered curd rice' }
    ],
    mantras: [
      {
        telugu: 'అంబా రౌద్రిణి భద్రాణీ శర్వాణీ సర్వమంగళా |\nఅపరాజితా భద్రకాళీ మంగళాయై నమో నమః ||',
        transliteration: 'Amba Raudrini Bhadrani Sharvani Sarvamangala | Aparajita Bhadrakali Mangalayai Namo Namah ||',
        meaning: 'Salutations to the Supreme Sovereign Empress of the Universe.'
      },
      {
        telugu: 'శ్రీవిద్యారాజ్ఞీ రాజ్ఞీ శ్రీచక్రరథారూఢా |\nజయంతి మంగళా కాళీ భద్రకాళీ కపాలినీ ||',
        transliteration: 'Sri Vidya Rajni Rajni Sri Chakra Ratharoodha | Jayanti Mangala Kali Bhadrakali Kapalini ||',
        meaning: 'Sovereign of Sri Vidya and ruler of Sri Chakra.'
      }
    ],
    rituals: [
      { title: 'Vijayadasami Maha Puja', titleTelugu: 'విజయదశమి మహా పూజ', description: 'Celebration of ultimate victory over evil' },
      { title: 'Shami / Jammi Puja', titleTelugu: 'శమీ పూజ (జమ్మి చెట్టు పూజ)', description: 'Worship of the sacred Shami tree for victory in all endeavors' },
      { title: 'Hamsa Vahana Teppotsavam', titleTelugu: 'హంస వాహన తెప్పోత్సవం', description: 'Grand swan-boat float festival of Durga Malleswara on the sacred Krishna river at twilight' },
      { title: 'Navaratri Deeksha Viramana', titleTelugu: 'భవాని దీక్ష విరమణ', description: 'Culmination and relinquishment of the Bhavani Deeksha by lakhs of pilgrims' }
    ],
    kalasaDetails: null,
    significance: 'Grand culmination of Dasara Navaratri! Goddess Kanaka Durga appears in her supreme peaceful empress form as Sri Raja Rajeswari Devi, bestowing victory, bliss, and supreme liberation.',
    significanceTelugu: 'దసరా నవరాత్రులలో పరిపూర్ణమైన చివరి అవతారం. దుష్ట శిక్షణ, శిష్ట రక్షణ చేసి భక్తులందరికీ విజయాన్ని, శాంతిని ప్రసాదించే జగన్మాతృ రూపం. సాయంత్రం కృష్ణా నదిలో జరిగే హంసవాహన తెప్పోత్సవంతో ఉత్సవాలు ముగుస్తాయి.'
  }
];
